import { render, staticRenderFns } from "./IntroValuesPage.vue?vue&type=template&id=2a871a8e&scoped=true&"
import script from "./IntroValuesPage.vue?vue&type=script&lang=js&"
export * from "./IntroValuesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a871a8e",
  null
  
)

export default component.exports